import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

const CustomerAutoComplete = () => {
	const [customerId, setCustomerId] = useState('');
	const [loading, setLoading] = useState(false);
	const [clientData, setClientData] = useState([]);
	const [filteredClients, setFilteredClients] = useState([]);
	const [searchValue, setSearchValue] = useState('');
	const [dropdownVisible, setDropdownVisible] = useState(true);
	const [highlightedIndex, setHighlightedIndex] = useState(-1);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const response = await axios.get('/get-client-data', {
					headers: { 'Content-Type': 'application/json' }
				});
				setClientData(response.data.data);
			} catch (error) {
				console.error('Failed to fetch client data');
			} finally {
				setLoading(false);
			}
		};

		fetchData(); // Initial fetch
		return () => setClientData([]); // Clean up
	}, []);

	useEffect(() => {
		if (searchValue.length > 2) {
			const filtered = clientData
				.filter((client) =>
					client.company_name.toLowerCase().includes(searchValue.toLowerCase()) ||
					client.customer_id.toString().includes(searchValue)
				)
				.slice(0, 30);

			setFilteredClients(filtered);
		} else {
			setFilteredClients([]);
		}
	}, [searchValue, clientData]);

	const handleOptionClick = (client) => {
		setCustomerId(client.customer_id);
		setSearchValue(client.company_name);
		setDropdownVisible(false);
		setInputFields(client);
	};

	const setInputFields = (client) => {
		document.querySelector('input[name="address"]').value = client.street_address;
		document.querySelector('input[name="company"]').value = client.company_name;
		document.querySelector('input[name="city"]').value = client.city;
		document.querySelector('select[name="state"]').value = client.state;
		document.querySelector('select[name="country"]').value = client.country == 'USA' ? 'US' : client.country;
		document.querySelector('input[name="zip"]').value = client.zip_code;
	};

	const handleKeyDown = (event) => {
		switch (event.key) {
			case 'ArrowUp':
				setHighlightedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
				break;
			case 'ArrowDown':
				setHighlightedIndex((prevIndex) => (prevIndex < filteredClients.length - 1 ? prevIndex + 1 : prevIndex));
				break;
			case 'Enter':
				if (highlightedIndex >= 0 && highlightedIndex < filteredClients.length) {
					handleOptionClick(filteredClients[highlightedIndex]);
				}
				break;
			default:
				break;
		}
	};

	return (
		<>
			{!loading && (
				<div
					className="position-relative mb-3"
					onMouseEnter={() => setDropdownVisible(true)}
					onMouseLeave={() => setDropdownVisible(false)}
					onFocus={() => setDropdownVisible(true)}
				>
					<label className="m-0">Shipping to Client...</label>
					<input
						type="text"
						className="form-control"
						value={searchValue}
						onChange={(e) => {
							setSearchValue(e.target.value);
							setDropdownVisible(true);
							setHighlightedIndex(-1);
						}}
						onKeyUp={handleKeyDown}
					/>
					<input type="hidden" name="customer_id" value={customerId} />

					{dropdownVisible && searchValue.length > 2 && (
						<div className="dropdown-menu show w-100">
							{filteredClients.map((client, index) => (
								<button
									key={client.customer_id}
									className={`dropdown-item ${highlightedIndex === index ? 'active' : ''}`}
									onClick={() => handleOptionClick(client)}
								>
									{client.company_name} ({client.customer_id})
								</button>
							))}
						</div>
					)}
				</div>
			)}
		</>
	);
};

if (document.getElementById('customerAutoComplete')) {
	ReactDOM.render(
		<CustomerAutoComplete />,
		document.getElementById('customerAutoComplete')
	);
}
